// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"503":"sql-formatter","736":"vendor"}[chunkId] + "." + {"503":"8b23c4aa60ee4a11f14e","736":"15536a29d7d69f313311"}[chunkId] + ".js";
};